import { useState, useEffect } from "react";
import Dropdown from "../../components/Dropdown";

const EditableResultDropdown = ({
  result,
  edit,
  setEdit,
  changeTo,
  setValue,
  setValue2,
  setValue3,
  changed,
  setBusinessSize,
  dropdown,
  setDropdown,
  styleNo,
  withBackground,
  autosave,
  query,
  setQuery,
  extraproperty,
  thirdproperty,
  disable,
}) => {
  const [tempValue, setTempValue] = useState(changeTo || "");
  const [extraValue, setExtraValue] = useState(null);
  const [thirdValue, setThirdValue] = useState(null);
  const handleEdit = () => {
    setEdit(true);
    setTempValue(changeTo);
  };
  const handleChange = (e) => {
    setTempValue(e.target.value);
  };

  const handleSaveChange = () => {
    setEdit(false);
    setValue(tempValue);
  };

  useEffect(() => {
    setTempValue(changeTo || "");
  }, [changeTo]);

  useEffect(() => {
    if (edit === true && changeTo !== undefined) {
      setTempValue(changeTo);
    }
  }, [edit, changeTo]);

  useEffect(() => {
    if (autosave) {
      setValue(tempValue);
      if (extraproperty) setValue2(extraValue);
      if (thirdproperty) setValue3(thirdValue);
    }
  }, [tempValue, extraValue]);

  useEffect(() => {
    if (changeTo === "Category") setTempValue(changeTo);
  }, [changeTo]);

  return (
    <>
      {!edit ? (
        <h4 className={changed ? "__changed" : null}>
          {result &&
          dropdown &&
          dropdown.length > 0 &&
          dropdown.filter((item) => item.id === result).length > 0
            ? dropdown.filter((item) => item.id === result)[0].value
            : result}
        </h4>
      ) : dropdown && dropdown.length > 0 ? (
        <Dropdown
          result={tempValue || changeTo}
          setBusinessSize={setTempValue}
          setExtraValue={
            extraproperty
              ? setExtraValue
              : function () {
                  return;
                }
          }
          setThirdValue={
            thirdproperty
              ? setThirdValue
              : function () {
                  return;
                }
          }
          list={dropdown}
          styleNo={styleNo}
          withBackground={withBackground}
          query={query}
          extravalue={extraproperty}
          thirdvalue={thirdproperty}
          disable={disable}
          setQuery={
            setQuery
              ? setQuery
              : function () {
                  return;
                }
          }
        />
      ) : null}
      {!edit ? (
        <>
          {/* <EditIcon style={{ marginLeft: 40, cursor: "pointer", color: "#476355" }} onClick={()=> handleEdit()}/> */}
        </>
      ) : (
        <>
          {/* Save changes */}
          {/* <CheckIcon style={{ marginLeft: 40, cursor: "pointer" }} onClick={() => handleSaveChange()}/> */}
          {/* Discard changes */}
          {/* <CloseIcon style={{ marginLeft: 8, cursor: "pointer" }} onClick={()=> setEdit(false)}/> */}
        </>
      )}
    </>
  );
};

export default EditableResultDropdown;
